import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TSwissPostApi } from './types';

export const swissPost: TSwissPostApi = {
	getConnectedEms: payload =>
		http
			.post(endpoint.swissPost.GET_SWISS_POST_CONNECTED_EMS, payload)
			.then(response => response.data),
	getAvailableEms: () =>
		http.post(endpoint.swissPost.GET_SWISS_POST_AVAILABLE_EMS).then(response => response.data),
	createSwissPost: payload =>
		http
			.post(endpoint.swissPost.CREATE_OR_UPDATE_SWISS_POST, payload)
			.then(response => response.data),
};
